import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import "./index.css"

import RootLayout from "./pages/Root"
import Broker from "./pages/Broker"
import ContactUs from "./pages/ContactUs"
import Homepage from "./pages/Homepage"
import Pricing from "./pages/Pricing"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import Redirect from "./pages/Redirect"
import Referral from "./pages/Referral"
import TermsOfService from "./pages/TermsOfService"
import SpeakWithExpert from "./pages/SpeakWithExpert"

const router = createBrowserRouter([
	{
		path: "/",
		element: <RootLayout />,
		children: [
			{
				index: true,
				element: <Homepage />
			},
			{
				path: "*",
				element: <Redirect />
			},
			{
				path: "contact-us",
				element: <ContactUs />
			},
			{
				path: "pricing",
				element: <Pricing />
			},
			{
				path: "privacy-policy",
				element: <PrivacyPolicy />
			},
			{
				path: "partners",
				element: <Broker />
			},
			{
				path: "referral-program",
				element: <Referral />
			},
			{
				path: "terms-of-service",
				element: <TermsOfService />
			},
			{
				path: "speak-with-an-hra-expert",
				element: <SpeakWithExpert />
			}
		]
	}
])

function App() {
	return (
		<HelmetProvider>
			<RouterProvider router={router} />
		</HelmetProvider>
	)
}

export default App
export { router }